(() => {
  const SDK_URL = 'https://player.vimeo.com/api/player.js';
  let sdkLoading = null;

  const loadSdk = () => {
    if (window.Vimeo && window.Vimeo.Player) return Promise.resolve();
    if (sdkLoading) return sdkLoading;
    sdkLoading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SDK_URL;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return sdkLoading;
  };

  const wireSync = async (section) => {
    const iframe = section.querySelector('iframe[src*="player.vimeo.com"], iframe[data-src*="player.vimeo.com"]');
    const segs = section.querySelectorAll('.transcript-seg[data-start]');
    if (!iframe || !segs.length) return;

    // Force src to load if lazyloaded
    if (!iframe.src && iframe.dataset.src) iframe.src = iframe.dataset.src;

    await loadSdk();
    const player = new window.Vimeo.Player(iframe);

    let lastActive = null;
    const setActive = (seg) => {
      if (lastActive === seg) return;
      if (lastActive) lastActive.classList.remove('is-active');
      if (seg) {
        seg.classList.add('is-active');
        const body = seg.closest('.video-section__transcript-body');
        if (body) {
          const segRect = seg.getBoundingClientRect();
          const bodyRect = body.getBoundingClientRect();
          if (segRect.top < bodyRect.top || segRect.bottom > bodyRect.bottom) {
            seg.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }
      }
      lastActive = seg;
    };

    player.on('timeupdate', ({ seconds }) => {
      let match = null;
      for (const s of segs) {
        const start = parseFloat(s.dataset.start);
        const end = parseFloat(s.dataset.end);
        if (seconds >= start && seconds < end) { match = s; break; }
      }
      setActive(match);
    });

    segs.forEach((seg) => {
      const seek = () => {
        const t = parseFloat(seg.dataset.start);
        player.setCurrentTime(t).catch(() => {});
        player.play().catch(() => {});
        const details = section.querySelector('.video-section__transcript');
        if (details && !details.open) details.open = true;
      };
      seg.addEventListener('click', seek);
      seg.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          seek();
        }
      });
    });
  };

  const init = () => {
    document.querySelectorAll('.video-section').forEach((section) => {
      if (section.dataset.syncWired === '1') return;
      section.dataset.syncWired = '1';
      wireSync(section).catch((e) => console.warn('video-transcript-sync:', e));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
